module.exports = __webpack_public_path__ + "assets/img/icon.3ab19eb2.svg";